// extracted by mini-css-extract-plugin
export default {"Wrapper":"Layout_Wrapper__DVjhj","main-content":"Layout_main-content__3OR9J","nav-hide":"Layout_nav-hide__VZQqp","children":"Layout_children__3swh-"};